import { Box, Grid } from "@mui/material";
import { times } from "lodash";
import CustomShimmer from "../../../components/CustomShimmer/CustomShimmer";
import { Colors } from "../../../styles/constant";

const FooterBannerSkeleton = () => {
  return (
    <Box
      marginTop="1.5rem"
      sx={{ backgroundColor: { xs: Colors.bgGray, md: Colors.white } }}
      padding="1rem"
    >
      <Grid container columnSpacing="1rem">
        {times(2, (index) => {
          return (
            <Grid item xs={6} key={index}>
              <Box
                display="flex"
                flexDirection="column"
                columnGap=".5rem"
                rowGap="1rem"
                padding="1rem 1.25rem"
                borderRadius="1.5rem"
                sx={{
                  backgroundColor: { xs: Colors.white, md: Colors.bgGray },
                }}
              >
                <Box
                  display="flex"
                  alignItems="center"
                  justifyContent="space-between"
                >
                  <CustomShimmer
                    width="40%"
                    height="4rem"
                    borderRadius=".25rem"
                  />
                  <CustomShimmer
                    width="2rem"
                    height="2rem"
                    borderRadius="1.5rem"
                  />
                </Box>
                <Box
                  display="flex"
                  flexDirection="column"
                  columnGap=".5rem"
                  rowGap=".5rem"
                >
                  <CustomShimmer
                    width="50%"
                    height="1rem"
                    borderRadius=".25rem"
                  />
                  <CustomShimmer
                    width="80%"
                    height="1rem"
                    borderRadius=".4375rem"
                  />
                  <CustomShimmer
                    width="80%"
                    height="1rem"
                    borderRadius=".4375rem"
                  />
                </Box>
              </Box>
            </Grid>
          );
        })}
      </Grid>
    </Box>
  );
};

export default FooterBannerSkeleton;
